import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import JobService from "services/jobAd";
import JobView from "./view";

class Job extends Component {
  state = {
    job: { company: {} },
    relatedJobs: [],
    loaded: false,
  };

  componentDidMount() {
    let jobID;
    const { match, history } = this.props;

    if (match) jobID = match.params.id;
    else history.push("/");

    this.getJobInfo(jobID);
  }

  getJobInfo = (jobID) => {
    const { history } = this.props;

    JobService.getJob(jobID).then((res) => {
      JobService.relatedJobs(res.category).then((relatedJobs) => {
        if (res && relatedJobs) {
          this.setState({ job: res, relatedJobs, loaded: true });
        } else history.push("/");
      });
    });
  };

  componentDidUpdate(prevProps, prevState) {
    let jobID;

    if (this.props.match && this.props.match !== prevProps.match) {
      this.setState({ jobs: [] });
      jobID = this.props.match.params.id;
      this.getJobInfo(jobID);
    }
  }

  render() {
    const { job, relatedJobs, loaded } = this.state;
    const { history } = this.props;
    const userLoggedIn = this.props.user.id && this.props.user.type === "user";
    const isCompany = this.props.user.id && this.props.user.type === "company";
    return (
      <JobView
        job={job}
        userLoggedIn={userLoggedIn}
        isCompany={isCompany}
        history={history}
        relatedJobs={relatedJobs}
        loaded={loaded}
      />
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Job));
